import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=38673bf4&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=js&"
export * from "./ImageView.vue?vue&type=script&lang=js&"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=38673bf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38673bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/nextcloud/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38673bf4')) {
      api.createRecord('38673bf4', component.options)
    } else {
      api.reload('38673bf4', component.options)
    }
    module.hot.accept("./ImageView.vue?vue&type=template&id=38673bf4&scoped=true&", function () {
      api.rerender('38673bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/text/src/nodes/ImageView.vue"
export default component.exports